import { type ObjectMode } from '@databases/types';
import { type Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { generateValuesForEntriesById } from '../utils.ts';

import { databasesToContentId } from './constants.ts';

export const getDatabaseWithContent = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getExistingDatabase({
    contentId: databasesToContentId['databaseWithContent'],
    databaseName: 'Database with content'
  });

  const fields = [
    ...Array.from({ length: 3 }, (_, index) => ({
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field ${index}`
    }))
  ];

  const entriesById = generateValuesForEntriesById(baseDatabase.entries, fields);

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    entriesById,
    entries: Object.keys(entriesById)
  };
};
